const ITEMS = [
  "Hourly Rentals",
  "Long Distance Journeys",
  "Local Intercity",
  "Airport to Airport",
  "Multi-Day Tours",
];

function Run({ hidden }) {
  return (
    <div className="flex items-center" aria-hidden={hidden || undefined}>
      {ITEMS.map((item) => (
        <span key={item} className="flex items-center">
          <span className="font-display uppercase font-black text-5xl md:text-7xl px-6 md:px-10 whitespace-nowrap">
            {item}
          </span>
          <span className="inline-block w-3 h-3 md:w-4 md:h-4 bg-ink rotate-45 shrink-0" />
        </span>
      ))}
    </div>
  );
}

export default function Marquee() {
  return (
    <section className="relative py-14 md:py-20 overflow-hidden" aria-label="Our services">
      <div className="marquee-band bg-signal text-ink -rotate-1 scale-[1.03] py-5 md:py-7 overflow-hidden">
        <div className="marquee-track" data-testid="marquee-track">
          <Run />
          <Run hidden />
        </div>
      </div>
    </section>
  );
}
